"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfirmFormLeave = void 0;
const use_confirm_form_leave_1 = require("./use-confirm-form-leave");
Object.defineProperty(exports, "useConfirmFormLeave", { enumerable: true, get: function () { return use_confirm_form_leave_1.useConfirmFormLeave; } });
